/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-05 16:18:54
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-08 17:06:41
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelLegal/tools.ts
 */
import React from 'react';

const generateList = ({ data, search }) => {
  return React.useMemo(() => {
    if (search) {
      const _pages = data.filter((page) => {
        const { name, remarks, contentAbbreviation } = page;
        if (
          name?.indexOf(search) !== -1 ||
          remarks?.indexOf(search) !== -1 ||
          (contentAbbreviation && contentAbbreviation.indexOf(search) !== -1)
        ) {
          return page;
        }
      });
      return _pages;
    }
    return data;
  }, [data, search]);
};

const duplicateErrCode = 104902;
export { generateList, duplicateErrCode };
